// extracted by mini-css-extract-plugin
export var imageFrame = "ImageModal-module--imageFrame--IOCgl";
export var modalContent = "ImageModal-module--modalContent--vnd9O";
export var close = "ImageModal-module--close--HnT9+";